import { csx } from '@vtex/admin-ui'

const styles = {
  description: csx({
    display: 'block',
    marginBottom: '$space-6',
  }),

  minQuantity: csx({
    display: 'inline-flex',
    marginX: '$space-2',
    input: { fieldSizing: 'content' },
    'span[role="alert"]': { maxWidth: '10rem' },
  }),
}

export default styles
